<template>
    <a class="logout" :href="config.cas_domin+'/bridge/do_logout.html?redirect='+encodeURIComponent(config.cas_domin+'/#/login?redirect='+encodeURIComponent(config.apps_domain+'/m/#/'))">退出当前登录</a>
</template>
<script>
    import config from "../../config/config.js";
    
    export default {
        name: "logout",
        data() {
            return {
                config: config
            };
        },
        methods: {
            
        }
    };
</script>
<style>
</style>